var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2829 16.6667H6.61621V30.0001C6.61621 35.0001 8.28288 36.6667 13.2829 36.6667H26.6162C31.6162 36.6667 33.2829 35.0001 33.2829 30.0001V16.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8337 11.6666V13.3333C35.8337 15.1666 34.9503 16.6666 32.5003 16.6666H7.50033C4.95033 16.6666 4.16699 15.1666 4.16699 13.3333V11.6666C4.16699 9.83325 4.95033 8.33325 7.50033 8.33325H32.5003C34.9503 8.33325 35.8337 9.83325 35.8337 11.6666Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 8.33324H10.2C9.6333 7.71657 9.64997 6.76657 10.25 6.16657L12.6166 3.7999C13.2333 3.18324 14.25 3.18324 14.8666 3.7999L19.4 8.33324Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.783 8.33324H20.583L25.1163 3.7999C25.733 3.18324 26.7497 3.18324 27.3663 3.7999L29.733 6.16657C30.333 6.76657 30.3497 7.71657 29.783 8.33324Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 16.6667V25.2334C14.9004 26.5667 16.3671 27.3501 17.4837 26.6334L19.0504 25.6001C19.6171 25.2334 20.3337 25.2334 20.8837 25.6001L22.3671 26.6001C23.4671 27.3334 24.9504 26.5501 24.9504 25.2167V16.6667H14.9004Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftWhite);
export default __webpack_public_path__ + "static/media/gift-white.a2418dac7a0959fdff8bbb09f3858553.svg";
export { ForwardRef as ReactComponent };